export default "__VITE_ASSET__B47yl0$W__"